// extracted by mini-css-extract-plugin
module.exports = {"c-clients-banner__wrapper":"ClientsBanner_c-clients-banner__wrapper__FgOU_"};